import { Spinner, SpinnerSize } from "@fluentui/react";
import { mergeStyleSets } from "@uifabric/merge-styles";
import { VehicleHistoryTable } from "components/VehicleHistoryTable";
import { useGetVehicleHistoryInformation } from "hooks/data/queries/useGetVehicleHistoryInformation";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { IStyledTheme } from "theme/types";
import { useSelector } from "../../../store/hooks";
import FormItemTitle from "../FormItemTitle";

const getClassNames = (theme: any) =>
  mergeStyleSets({
    container: {
      padding: 40,
    },
    gridRoot: {
      display: "grid",
      margin: "15px 0px 0px 50px",
      gridTemplateColumns: "50% 50%",
    },
    previewLabel: {
      fontWeight: 600,
      fontSize: "14px",
      marginTop: "10px",
      color: theme.palette.black,
    },
    previewValue: {
      fontWeight: "normal",
      color: theme.palette.black,
    },
    isMarked: {
      background: theme.palette.yellowLight,
      color: theme.palette.black,
    },
    coverageContainer: {
      marginTop: "5px",
    },
    coverageItem: {
      marginBottom: "6px",
      paddingLeft: "12px",
    },
    coverageName: {
      fontWeight: 600,
      marginBottom: "2px",
    },
    coverageDates: {
      fontSize: "12px",
      color: theme.palette.neutralSecondary,
    },
  });

const HistoryPreview = ({ vehicle, readOnly }) => {
  const theme = useTheme() as IStyledTheme;
  const { t } = useTranslation();
  const vehicleAppSettings = useSelector((s) => s.vehicle.vehicleAppSettings);

  const classes = getClassNames(theme);

  const { data: vehicleHistoryData, isLoading: isVehicleHistoryLoading } =
    useGetVehicleHistoryInformation({
      fleetId: vehicle?.fleetId,
      vehicleId: vehicle?.vehicleId,
      enabled:
        !!vehicleAppSettings &&
        vehicleAppSettings?.HAS_VEHICLE_HISTORY &&
        !!vehicle,
    });
  return (
    <div className={classes.container}>
      {readOnly && (
        <FormItemTitle
          title={t("bfm.vehicle.tabs.history")}
          iconName={"History"}
          iconMargin={0}
        />
      )}
      {isVehicleHistoryLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <Spinner size={SpinnerSize.large} label={t("greco.loading")} />
        </div>
      ) : (
        <VehicleHistoryTable
          data={vehicleHistoryData || []}
          showUrgent={!!vehicleAppSettings?.SHOW_URGENT_ON_STATUS_CHANGE}
        />
      )}{" "}
    </div>
  );
};

export default HistoryPreview;
